<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-11-12 11:16:25
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2025-01-23 10:22:00
 * @FilePath: \spread_star_website\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <!-- <div v-if="isDesktopApp" style="width: 100%;height: 40px;background-color: aqua;position: fixed;top: 0;z-index: 9999;"></div> -->
    
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <keep-alive>
      <router-view v-if="!$route.meta.keepAlive"/>
    </keep-alive> -->
    <router-view />
  </div>
</template>
<script>
export default{
  data(){
    return{
      isDesktopApp:false
    }
  },
  created(){
    //  this.isDesktopApp = window.matchMedia('(display-mode: standalone)').matches || window.matchMedia('(display-mode: fullscreen)').matches;
    // console.log(this.isDesktopApp);
    },
}
</script>

<style lang="less">
html{
  overflow-y: scroll; /* 始终保留滚动条的空间 */
}
body,
#app {
  height: 100%;
  background-color: #f2f3f5;
}
::-webkit-scrollbar {
  width: 8px;
  height: 10px;
  display: none;
}

::-webkit-scrollbar-track {
  width: 6px;
  background: rgba(#101f1c, 0.1);
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(144, 147, 153, 0.5);
  background-clip: padding-box;
  min-height: 28px;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
  transition: background-color 0.3s;
  cursor: pointer;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(144, 147, 153, 0.3);
}

.el-menu-item:hover {
  background-color: transparent !important; /* 使用 !important 确保覆盖 */
}

.el-menu-item {
  background-color: transparent !important; /* 使用 !important 确保覆盖 */
}

</style>
